<template lang="pug">
  .operator-table__table.scroll-fix-table.open-table
    vue-custom-scrollbar(
    class="table-wrapper"
      :settings="settings"
    )
      table.table
        thead.table__head
          tr.table__row
            th.table__cell(v-for="head in tab_head")
              .table__cell-content {{ head.title }}
            th.table__cell.fixed
              .table__cell-content

        tbody.table__body
          tr.table__row(v-for="item in tab_data")
            td.table__cell
              .table__cell-content
                .toggle {{item.name}}
            td.table__cell
              .table__cell-content {{item.date}}
            td.table__cell
              .table__cell-content {{item.price}}
            td.table__cell
              .table__cell-content {{item.number}}
            td.table__cell.fixed
              .table__cell-content
                router-link.button.button--edit(to="/pages/manager/camp-edit")
                .more
          tr.table__row.is-open
            td.table__cell
              .table__cell-content
                .toggle Смена 4
            td.table__cell
              .table__cell-content 14.08 - 15.09.18
            td.table__cell
              .table__cell-content 10 457 р.
            td.table__cell
              .table__cell-content 90
            td.table__cell.fixed
              .table__cell-content
                router-link.button.button--edit(to="/pages/manager/camp-edit")
                .more
          tr.is-opened
            td(colspan="5").is-opened__content
              table.table-inner
                thead
                  tr.table__row
                    th.table__cell
                      .table__cell-content Квота
                    th.table__cell
                      .table__cell-content Кол-во человек
                    th.table__cell
                      .table__cell-content Цена
                    th.table__cell
                      .table__cell-content Организация
                    th.table__cell
                      .table__cell-content Корпус
                    th.table__cell
                tbody.table__body
                  tr.table__row
                    td.table__cell
                      .table__cell-content Гимнасты
                    td.table__cell
                      .table__cell-content 15
                    td.table__cell
                      .table__cell-content 5000
                    td.table__cell
                      .table__cell-content АССШ 45
                    td.table__cell
                      .table__cell-content №4, №5, №6
                    td.table__cell
                  tr.table__row
                    td.table__cell
                      .table__cell-content Гимнасты
                    td.table__cell
                      .table__cell-content 15
                    td.table__cell
                      .table__cell-content 5000
                    td.table__cell
                      .table__cell-content АССШ 45
                    td.table__cell
                      .table__cell-content №7
                    td.table__cell
              .button-container.form__elem--align-right.form__elem_full
                router-link.button.button_paint-main--transparent(
                to="/pages/director/shift/quota/create"
                )
                  .button__text Добавить квоту
              //.button-container.button-container_align-right
                .button.button_paint-main Добавить квоту

          tr.table__row
            td.table__cell
              .table__cell-content
                .toggle Смена 5
            td.table__cell
              .table__cell-content 14.08 - 15.09.18
            td.table__cell
              .table__cell-content 10 457 р.
            td.table__cell
              .table__cell-content 190
            td.table__cell.fixed
              .table__cell-content
                router-link.button.button--edit(to="/pages/manager/camp-edit")
                .more
</template>
<script>
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  name: "director-table",
  props: ["tab_data", "tab_head"],
  components: {
    vueCustomScrollbar
  },
  data() {
    return {
      settings: {
        useBothWheelAxes: true
      }
    };
  }
};
</script>
